import { Button } from '@vrplatform/components';
import { showApiErrorNotification, useApiMutation } from '@vrplatform/data';
import type { syncStatus_enum } from '@vrplatform/graphql';
import { useCallback } from 'react';

export const AutomationHistoryRerunButtons = ({
  sync,
  refetch,
}: {
  sync: {
    id: string;
    status: syncStatus_enum;
  };
  refetch: () => void;
}) => {
  'use memo';

  const { mutateAsync, isPending: loadingCancel } = useApiMutation(
    'post',
    '/syncs/{id}/cancel'
  );

  const cancelWorkflow = useCallback(async () => {
    await mutateAsync({
      params: {
        path: {
          id: sync.id,
        },
      },
    })
      .then(refetch)
      .catch((error) => {
        showApiErrorNotification({
          error,
          title: 'Failed to cancel workflow',
          defaultMessage:
            'Please try again later and contact support if the issue persists.',
        });
      });
  }, [sync.id, mutateAsync, refetch]);

  if (
    sync.status === 'completed' ||
    sync.status === 'failed' ||
    sync.status === 'canceled'
  )
    return null;

  return (
    <Button
      color="red"
      loading={loadingCancel}
      leftIcon={'CrossCircleIcon'}
      onClick={cancelWorkflow}
    >
      Cancel
    </Button>
  );
};
